import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";
import { formatDetail } from "@/lib/api";

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await login(email, password);
      toast.success("Welcome back, hunter.");
      nav("/");
    } catch (e) {
      toast.error(formatDetail(e.response?.data?.detail) || "Login failed");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-6 relative overflow-hidden">
      <div className="noise-overlay" />
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[500px] h-[500px] rounded-full bg-violet-600/10 blur-[100px]" />
      <div className="absolute bottom-0 right-0 w-[400px] h-[400px] rounded-full bg-cyan-500/10 blur-[100px]" />

      <div className="relative z-10 w-full max-w-md">
        <div className="text-center mb-8">
          <div className="inline-flex items-center gap-2 mb-4">
            <div className="w-10 h-10 border border-cyan-400/50 flex items-center justify-center">
              <span className="text-cyan-400 font-display font-bold text-lg">S</span>
            </div>
            <span className="font-display font-bold tracking-[0.3em] text-lg">SOLO ASCEND</span>
          </div>
          <h1 className="h-display text-3xl sm:text-4xl">
            System <span className="text-cyan-400">Login</span>
          </h1>
          <p className="mt-2 text-sm text-slate-400">
            You have been chosen. Awakening in progress...
          </p>
        </div>

        <form onSubmit={submit} className="panel panel-corners p-6 space-y-4">
          <div>
            <label className="label-tech block mb-1.5">Hunter ID</label>
            <input
              data-testid="login-email"
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full bg-black/60 border border-white/10 focus:border-cyan-400/60 outline-none px-3 py-2.5 text-white font-mono-tech text-sm"
              placeholder="hunter@ascend.system"
            />
          </div>
          <div>
            <label className="label-tech block mb-1.5">Access Key</label>
            <input
              data-testid="login-password"
              type="password"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full bg-black/60 border border-white/10 focus:border-cyan-400/60 outline-none px-3 py-2.5 text-white font-mono-tech text-sm"
              placeholder="••••••••"
            />
          </div>

          <button
            data-testid="login-submit"
            disabled={busy}
            type="submit"
            className="btn-neon w-full text-center"
          >
            {busy ? "Authenticating..." : "Enter System"}
          </button>

          <p className="text-center text-xs text-slate-400 pt-2">
            No account yet?{" "}
            <Link data-testid="link-register" to="/register" className="text-cyan-400 hover:text-cyan-300">
              Begin Awakening
            </Link>
          </p>
        </form>
      </div>
    </div>
  );
}
